var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { merge } from "lodash";
import { createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { createLayout } from "./layout";
import { createMixins } from "./mixins";
import { createOverrides } from "./overrides";
import { createPalette } from "./palette";
import { createSpacing } from "./spacing";
import { createTypography } from "./typography";
export var createTheme = function (_a) {
    if (_a === void 0) { _a = {}; }
    var breakpointsOptions = _a.breakpoints, spacingOption = _a.spacing, paletteOptions = _a.palette, typographyOptions = _a.typography, mixinsOptions = _a.mixins, propsOptions = _a.props, overridesOptions = _a.overrides, layoutOptions = _a.layout, additionalOptions = __rest(_a, ["breakpoints", "spacing", "palette", "typography", "mixins", "props", "overrides", "layout"]);
    var spacing = createSpacing();
    var palette = createPalette(paletteOptions);
    var typography = createTypography(palette, typographyOptions);
    var breakpoints = createBreakpoints(breakpointsOptions || {});
    var mixins = createMixins({
        palette: palette,
        spacing: spacing,
        breakpoints: breakpoints,
        overrides: mixinsOptions,
    });
    var layout = createLayout(layoutOptions);
    var _b = createOverrides({
        spacing: spacing,
        breakpoints: breakpoints,
        mixins: mixins,
        palette: palette,
        typography: typography,
        layout: layout,
        props: propsOptions,
        overrides: overridesOptions,
    }), props = _b.props, overrides = _b.overrides;
    var defaultOptions = {
        palette: palette,
        spacing: spacing,
        typography: typography,
        breakpoints: breakpoints,
        mixins: mixins,
        props: props,
        overrides: overrides,
        layout: layout,
        shadows: __spread([
            "none",
            "0px 2px 4px rgba(0, 0, 0, 0.12)",
            "0px 6px 8px rgba(0, 0, 0, 0.1)",
            "0px 12px 12px rgba(0, 0, 0, 0.1)"
        ], Array.from({ length: 20 }).map(function () { return "0px 16px 16px rgba(0, 0, 0, 0.1)"; })),
    };
    return createMuiTheme(merge(defaultOptions, additionalOptions));
};
export var theme = createTheme();
